import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

import { showAtpPopupAction } from '@interlayer/js/app/components/popups/AtpPopup/actions';
import { useConfigTag } from '@interlayer/js/app/hooks/useConfigTag';
import { useLoginPopup } from '@interlayer/js/components/popups/LoginPopup/hooks';
import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';

import { TAtpButton } from '../types';

export const useRunAtp = ({ schedule, type, name }: TAtpButton) => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const showLoginPopup = useLoginPopup();
    const dispatch = useDispatch();
    const atpSettings = useConfigTag(CONFIG_TAG_TYPE.atpSettings);

    return useCallback(() => {
        if (!type || !name || !schedule || !atpSettings) {
            return;
        }

        if (!isLoggedIn) {
            showLoginPopup({
                onLogin: () => {
                    dispatch(showAtpPopupAction({ schedule, type, name }));
                }
            });

            return;
        }

        dispatch(showAtpPopupAction({ schedule, type, name }));
    }, [dispatch, isLoggedIn, name, schedule, showLoginPopup, type, atpSettings]);
};
